import { Injectable, signal } from '@angular/core';

/**
 * Drives the Toolbox drawer (a top-sliding panel of quick floating tools —
 * Calculator, Currency Converter, Wallboard). The topbar button toggles it;
 * the global {@code ToolboxComponent} host (mounted at app root) renders the
 * drawer + floating windows off this signal. Kept trivially small so both the
 * button and the host share one source of truth.
 */
@Injectable({ providedIn: 'root' })
export class ToolboxService {
  /** Whether the tool-picker drawer is slid open. */
  readonly open = signal(false);

  toggle(): void { this.open.update((o) => !o); }
  close(): void { this.open.set(false); }
}
